import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';

export const getPrivateIdUsers = createAsyncThunk(
    'privateIdUsers/getPrivateIdUsers',
    async () => {
        const { data } = await http.get('api/v1/testing/delete-my-data/accounts');
        return data.data;
    },
);

export const createPrivateIdUser = createAsyncThunk(
    'privateIdUsers/createPrivateIdUser',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post(
                'api/v1/testing/delete-my-data/accounts',
                body,
            );
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const updatePrivateIdUser = createAsyncThunk(
    'clients/updatePrivateIdUser',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(
                `api/v1/testing/delete-my-data/account/${id}`,
                body,
            );
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deletePrivateIdUser = createAsyncThunk(
    'privateIdUsers/deletePrivateIdUser',
    async (id, { rejectWithValue }) => {
        try {
            await http.delete(`api/v1/testing/delete-my-data/accounts/${id}`);
            return id;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

const initialState = {
    usersLoadingStatus: 'idle',
    users: [],
    errors: {},
};

export const privateIdUsersSlice = createSlice({
    name: 'privateIdUsers',
    initialState,
    reducers: {},
    extraReducers: {
        [getPrivateIdUsers.pending]: (state) => {
            state.usersLoadingStatus = 'loading';
        },
        [getPrivateIdUsers.fulfilled]: (state, action) => {
            state.usersLoadingStatus = 'succeeded';
            state.users = action.payload || [];
        },
        [getPrivateIdUsers.rejected]: (state, action) => {
            state.usersLoadingStatus = 'failed';
            state.errors = action.error;
        },
    },
});

/* Selectors */
export const privateIdUsers = (state) => state.privateIdUsers.users;
export const privateIdUsersLoadingStatus = (state) =>
    state.privateIdUsers.usersLoadingStatus;

export default privateIdUsersSlice.reducer;

